__turbopack_context__.v({
  "className": "montserrat_bb6e49d8-module__wbBg_q__className",
});
